import i18n from '@/i18n';
import ProductPage from '@/pages/ProductPage/ProductPage.vue';
import { createPinia } from 'pinia';
import { createPersistedState } from 'pinia-plugin-persistedstate';
import 'vite/modulepreload-polyfill';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { createApp } from 'vue';
import VueLazyload from 'vue3-lazyload';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { vAutoAnimate } from '@formkit/auto-animate';

library.add(fas, fab, far);

// @ts-ignore TS7016 Vue instantsearch doesn't have typehints
import InstantSearch from 'vue-instantsearch/vue3/es';

createApp(ProductPage)
  .use(i18n)
  .use(VueLazyload, {})
  .use(InstantSearch)
  .use(createPinia().use(createPersistedState({ storage: localStorage })))
  .component('font-awesome-icon', FontAwesomeIcon)
  .directive('auto-animate', vAutoAnimate)
  .mount('#configurator-app');
